var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[(_vm.isBlank)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"headline"},[_vm._v("Виберіть курс")]),_c('v-list',{attrs:{"dense":""}},[_c('navigation-nav-list-semesters',{attrs:{"route-to":"lecturesFullRoot"}})],1)],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }